module.exports = __webpack_public_path__ + "static/Moonlighter4-3c15b34db3159ae48c4b543956b62f7c.png";